// @flow

import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { log } from '../../utils/jsUtils';
import { auth } from '../../services/firebase';
import { signInWithEmailAndPassword, getIdToken, sendPasswordResetEmail } from 'firebase/auth';
import { login } from '../../reduxStore/modules/user/actions';
import { setSnackMessage } from '../../reduxStore/modules/common/actions';
import { selectIsLoggedIn } from '../../reduxStore/modules/user/selectors';

const useUserAuth = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  // Use Redux hooks only
  const dispatch = useDispatch();
  const loggedIn = useSelector(selectIsLoggedIn);

  const verifyAccountSetup = () => {
    /**
     * 1. account has a plan? no: /plans, on select plan: /checkout?planId=xxxx
     * 2. account has paid for this plan? no: back to step 1.
     * 3. account has at least one building? no: /setup-property
     * 4. else: /member
     */
    // if account.billing.planId not set, then redirect to plan selection page
    // if account.billing.
  };

  const authenticate = async (e) => {
    if (e) {
      e.preventDefault();
    }
    
    log('[authenticate] Starting authentication for email:', email);
    
    try {
      // Use Redux login action
      log('[authenticate] Dispatching login action...');
      const result = await dispatch(login(email, password));
      
      log('[authenticate] Login result:', result);
      
      if (!result.success) {
        log('[authenticate] Login failed');
      } else {
        log('[authenticate] Login successful');
      }
    } catch (error) {
      log('[authenticate] Error during authentication:', error);
    }
  };

  const handleResetPwd = async (e) => {
    if (e) {
      e.preventDefault();
    }
    
    try {
      log('[handleResetPwd] Sending password reset for:', email);
      await sendPasswordResetEmail(auth, email);
      
      dispatch(setSnackMessage({
        message: 'Password reset email sent. Please check your inbox.',
        level: 'success',
        duration: 5000
      }));
      
      log('[handleResetPwd] Password reset email sent');
    } catch (err) {
      log('[handleResetPwd] Error sending password reset:', err);
      
      dispatch(setSnackMessage({
        message: 'Failed to send password reset email. Please try again.',
        level: 'error',
        duration: 5000
      }));
    }
  };

  return { authenticate, handleResetPwd, email, setEmail, password, setPassword, loggedIn };
};

export {
  useUserAuth
};
